(function () {
  console.log('[Mattress Addon] script loaded');
  function qs(sel, root = document) {
    return root.querySelector(sel);
  }
function hydrateMattressCards(selectedSize) {
  const items = document.querySelectorAll('.mattress-addon-item');
  let shown = 0;

  items.forEach((item) => {
    const raw = item.getAttribute('data-variants') || '[]';
    let variants = [];
    try {
      variants = JSON.parse(raw);
    } catch (e) {
      variants = [];
    }

    const match = variants.find(v => (v.size || '').trim() === selectedSize.trim());

    if (!match) {
      item.style.display = 'none';
      return;
    }

    item.style.display = '';
    shown += 1;

const drawer = document.getElementById('mattress-addon-drawer');
const discountPercent = drawer ? Number(drawer.getAttribute('data-discount-percent') || 0) : 0;
const discountFixed = drawer ? Number(drawer.getAttribute('data-discount-fixed') || 0) : 0; // £ amount

const formatMoney = (cents) => {
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents);
  }
  return '£' + (cents / 100).toFixed(2);
};

const applyDiscount = (priceCents) => {
  let out = priceCents;

  if (discountPercent > 0) {
    out = Math.round(priceCents * (100 - discountPercent) / 100);
  } else if (discountFixed > 0) {
    out = Math.max(priceCents - Math.round(discountFixed * 100), 0);
  }

  return out;
};

const priceEl = item.querySelector('.mattress-addon-item__price');
if (priceEl) {
  const priceCents = Number(match.price_cents);
  const compareCents = Number(match.compare_at_cents);

  const hasCompare = Number.isFinite(compareCents) && compareCents > priceCents;
  const discountedCents = Number.isFinite(priceCents) ? applyDiscount(priceCents) : priceCents;

  const badge =
    discountPercent > 0 ? `(${discountPercent}% off)` :
    discountFixed > 0 ? `(£${discountFixed} off)` :
    ``;

  priceEl.innerHTML = `
    ${hasCompare ? `
      <div style="opacity:.8;font-size:.9em;">
        <span>RRP:</span> <s>${formatMoney(compareCents)}</s>
      </div>
    ` : ``}

    <div style="opacity:.85;font-size:.9em;">
      <span>Current Price:</span> <s>${formatMoney(priceCents)}</s>
    </div>

    <div style="margin-top:4px;">
      <span style="opacity:.85;font-size:.9em;">Price with Discount:</span>
      <div><strong>${formatMoney(discountedCents)}</strong> ${badge ? `<span style="opacity:.75;font-size:.9em;">${badge}</span>` : ``}</div>
    </div>
  `;
}




    const btn = item.querySelector('.mattress-addon-add');
    if (btn) btn.setAttribute('data-variant-id', String(match.id));
  });

  // Optional: if nothing matches, show a message
  const panel = document.querySelector('.mattress-addon-panel');
  if (panel) {
    const existing = panel.querySelector('.mattress-addon-none');
    if (existing) existing.remove();

    if (shown === 0) {
      const p = document.createElement('p');
      p.className = 'mattress-addon-none';
      p.textContent = `No compatible mattresses available for size: ${selectedSize}`;
      panel.appendChild(p);
    }
  }
}
async function addVariantToCart(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity })
  });

  if (!res.ok) {
    let msg = `Unable to add item (HTTP ${res.status}).`;
    try {
      const err = await res.json();
      if (err && err.description) msg = err.description;
    } catch (_) {}
    throw new Error(msg);
  }

  return res.json();
}

// Add-to-cart from drawer
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.mattress-addon-add');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) {
    alert('Please select a size first.');
    return;
  }

  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = 'Adding…';

  try {
    await addVariantToCart(variantId, 1);
    btn.textContent = 'Added';

    // Attempt to trigger theme cart refresh (Boost/theme dependent)
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.body.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    // Optional: close drawer after add
    // closeDrawer();

  } catch (err) {
    console.error('[Mattress Addon] add to cart error:', err);
    alert(err.message || 'Unable to add mattress.');
    btn.textContent = originalText;
  } finally {
    btn.disabled = false;
    setTimeout(() => {
      btn.textContent = originalText;
    }, 1200);
  }
}, true);

  function getDrawerEls() {
    return {
      drawer: qs('#mattress-addon-drawer'),
      overlay: qs('.mattress-addon-overlay'),
      results: qs('.mattress-addon-results'),
      loading: qs('.mattress-addon-loading'),
      trigger: qs('.mattress-addon-trigger'),
    };
  }

  function getSelectedSizeFromPicker() {
    const checked = qs('input[type="radio"][name*="size-option"]:checked');
    return checked ? checked.value.trim() : '';
  }

  async function loadPanel() {
    const { drawer, results, loading } = getDrawerEls();
    if (!drawer || !results || !loading) return;

    const size = getSelectedSizeFromPicker();
    drawer.dataset.selectedSize = size;
    console.log('[Mattress Addon] size detected:', size);

    if (!size) {
      results.innerHTML = '<p>Please select a size to view matching mattresses.</p>';
      loading.hidden = true;
      results.hidden = false;
      return;
    }

    loading.hidden = false;
    results.hidden = true;

    const url = new URL(window.location.origin + window.location.pathname);
    url.searchParams.set('sections', 'mattress-addon-content');
    url.searchParams.set('size', size);

    console.log('[Mattress Addon] fetch url:', url.toString());

    try {
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      const sectionHtml = data && data['mattress-addon-content'];

results.innerHTML = sectionHtml ? sectionHtml : '<p>Unable to load mattresses.</p>';
if (sectionHtml) hydrateMattressCards(size);
    } catch (e) {
      console.error('[Mattress Addon] loadPanel error:', e);
      results.innerHTML = '<p>Unable to load mattresses.</p>';
    }

    loading.hidden = true;
    results.hidden = false;
  }

 function openDrawer() {
  const { drawer, overlay } = getDrawerEls();
  if (!drawer || !overlay) return;

  drawer.classList.add('is-open');
  overlay.hidden = false;
  document.body.classList.add('mattress-addon-lock');

  // If something re-renders and removes the class, this will catch it
  setTimeout(() => {
    console.log('[Mattress Addon] drawer open state after tick:', drawer.classList.contains('is-open'));
  }, 50);

  loadPanel();

  const btn = drawer.querySelector('.mattress-addon-close');
  if (btn) btn.focus();
}


  function closeDrawer() {
    const { drawer, overlay, trigger } = getDrawerEls();
    if (!drawer || !overlay) return;

    drawer.classList.remove('is-open');
    overlay.hidden = true;
    document.body.classList.remove('mattress-addon-lock');

    if (trigger) trigger.focus();
  }

  // Delegated click events (survive Boost/APO re-renders)
 document.addEventListener('click',
  (e) => {
    const triggerEl = e.target.closest('.mattress-addon-trigger');
    if (triggerEl) {
      e.preventDefault();
      console.log('[Mattress Addon] trigger clicked');
      openDrawer();
      return;
    }

    if (e.target.closest('.mattress-addon-close') || e.target.closest('.mattress-addon-overlay')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
  },
  true // <-- capture phase
);

  // If size changes while drawer open, refresh content
document.addEventListener('change', (e) => {
  if (e.target && e.target.matches('input[type="radio"][name*="size-option"]')) {
    const drawerEl = document.getElementById('mattress-addon-drawer');
    if (drawerEl && drawerEl.classList.contains('is-open')) {
      loadPanel();
    }
  }
});

})();
